import React from "react";
import mtext from "../images/mtitle.jpg"
import "../App.css";



const Header = () => {

    return (
        <>
            <div className="w-100">
                <div className="row .bg-info.bg-gradient">
                    <div className="float-left  text-center">
                        <img class="img-fluid text-center" src={mtext} alt={mtext} width="1000" height="100" />
                    </div>
                </div>
                <div className="row">
                    <div className="hr-primary">
                        <ol class="breadcrumb bread-primary "></ol>
                    </div>
                </div>
            </div>

        </>
    );
};
export default Header;